export const inquiryTypes = [
  'Private Party',
  'Catering',
  'Reservation',
  'Job Listings',
  'Delivery Order',
  'Pick Up Order',
  'Other',
  'Unknown',
  'Other Custom',
] as const

export const inquiryStatuses = [
  'unconfirmed',
  'confirmed',
  'autoresponse sent',
  'waiting on customer',
  'waiting on you',
  'paused',
  'cancelled',
  'no showed',
] as const

export const reservationInquiryStatuses = [
  'unconfirmed',
  'confirmed',
  'waiting on customer',
  'waiting on you',
  'paused',
  'cancelled',
  'no showed',
] as const

export const otherCustomInquiryStatuses = [
  'unconfirmed',
  'confirmed',
  'waiting on you',
  'waiting on customer',
  'paused',
  'cancelled',
  'no showed',
  'received',
]

export const otherInquiryStatuses = [
  'received',
  'waiting on you',
  'waiting on customer',
  'resolved',
]

export const jobListingStatuses = [
  'applied',
  'not a good fit',
  'scheduled for interview',
  'interviewed',
  'follow up in the future',
  'hired',
  'no showed interview',
  'not hired',
] as const

export const deliveryOrderStatuses = [
  'accepted',
  'accepted, arrange pickup',
  'received',
  'in route',
  'delivered',
  'rejected',
] as const

export const pickUpOrderStatuses = [
  'accepted',
  'received',
  'ready for pick up',
  'picked up',
  'rejected',
] as const

export const allStatuses = [
  ...inquiryStatuses,
  ...jobListingStatuses,
  ...deliveryOrderStatuses,
  ...pickUpOrderStatuses,
] as const

export const showFilterData = [
  {
    label: 'Upcoming inquiries',
    shortLabel: 'Upcoming',
  },
  {
    label: 'Unanswered inquiries',
    shortLabel: 'Unanswered',
  },
  {
    label: 'Previous inquiries',
    shortLabel: 'Previous',
  },
]

export const showSortData = [
  {
    label: 'Received: Latest inquiries',
    shortLabel: 'Received',
  },
  {
    label: 'Requested Date: Closest First',
    shortLabel: 'Requested',
  },
  {
    label: 'Status: Priority - High to low',
    shortLabel: 'Status',
  },
  {
    label: 'Type: Inquiry category',
    shortLabel: 'Type',
  },
  {
    label: 'Name: Sorted alphabetically A - Z',
    shortLabel: 'Name',
  },
]

export const calendarFilters = {
  inquiry: [
    {
      type: 'party',
      active: true,
      status: {
        unconfirmed: true,
        confirmed: true,
        autoresponse_sent: true,
        waiting_on_customer: true,
        waiting_on_you: true,
        paused: true,
        cancelled: true,
        no_showed: true,
      },
    },
    {
      type: 'catering',
      active: true,
      status: {
        unconfirmed: true,
        confirmed: true,
        autoresponse_sent: true,
        waiting_on_customer: true,
        waiting_on_you: true,
        paused: true,
        cancelled: true,
        no_showed: true,
      },
    },
    {
      type: 'reservation',
      active: true,
      status: {
        unconfirmed: true,
        confirmed: true,
        waiting_on_customer: true,
        waiting_on_you: true,
        paused: true,
        cancelled: true,
        no_showed: true,
      },
    },
    {
      type: 'job',
      active: true,
      status: {
        applied: true,
        not_a_good_fit: true,
        scheduled_for_interview: true,
        interviewed: true,
        follow_up_in_the_future: true,
        hired: true,
        no_showed_interview: true,
        not_hired: true,
      },
    },
  ],
  marketing: [
    {
      type: 'facebook',
      active: true,
    },
    {
      type: 'instagram',
      active: true,
    },
    {
      type: 'email',
      active: true,
    },
    {
      type: 'text',
      active: true,
    },
    {
      type: 'special',
      active: true,
    },
    {
      type: 'event',
      active: true,
    },
    {
      type: 'website',
      active: true,
    },
    {
      type: 'review',
      active: true,
    },
  ],
} as const

export const PROMOTIONS = [
  {
    id: 'holiday_parties',
    displayName: 'Holiday Parties',
    filenameSlug: 'holiday_parties',
    pattern: /holiday_promotions/,
  },
  {
    id: 'super_bowl',
    displayName: 'Super Bowl',
    filenameSlug: 'super_bowl',
    pattern: /superbowl/,
  },
  {
    id: 'valentines_day',
    displayName: "Valentine's Day",
    filenameSlug: 'valentines_day',
    pattern: /valentines/,
  },
  {
    id: 'st_patricks_day',
    displayName: "St. Patrick's Day",
    filenameSlug: 'st_patricks_day',
    pattern: /st_patrick(_s_day|s)/,
  },
  {
    id: 'easter',
    displayName: 'Easter',
    filenameSlug: 'easter',
    pattern: /easter/,
  },
  {
    id: 'mothers_day',
    displayName: "Mother's Day",
    filenameSlug: 'mothers_day',
    pattern: /mothers_day/,
  },
  {
    id: 'cinco_de_mayo',
    displayName: 'Cinco de Mayo',
    filenameSlug: 'cinco_de_mayo',
    pattern: /cinco_de_mayo/,
  },
  {
    id: 'fathers_day',
    displayName: "Father's Day",
    filenameSlug: 'fathers_day',
    pattern: /fathers_day/,
  },
  {
    id: 'independence_day',
    displayName: 'Independence Day',
    filenameSlug: 'independence_day',
    pattern: /independence_day/,
  },
  {
    id: 'graduation',
    displayName: 'Graduation Season',
    filenameSlug: 'graduation',
    pattern: /graduation/,
  },
]
